var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, ChangeDetectorRef, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation/navigation.service';
import { NavigableComponent } from '../../model/navigable-component';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { Router } from '@angular/router';
import { TvShopStateService } from '../../services/state/tv-shop-state.service';
import { PageNames } from '../../shared/page-names.enum';
import { ProductTypeRenditionEnum } from '../../constants/renditions/product-type-rendition.constants';
import { TvShopEntertainmentPackGroupIds } from '../../constants/tv-shop-entertainment-pack/tv-shop-entertainment-pack-group.constants';
import { OmapiIdsUtils } from '../../shared/utils/omapi-ids/omapi-ids-utils';
import { StreamingServicesUtil } from '../../utils/streaming-services.util';
var NetflixServicesDetailsComponent = /** @class */ (function (_super) {
    __extends(NetflixServicesDetailsComponent, _super);
    function NetflixServicesDetailsComponent(navigationService, changeDetector, analyticsService, stateService, router) {
        var _this = _super.call(this, navigationService) || this;
        _this.navigationService = navigationService;
        _this.changeDetector = changeDetector;
        _this.analyticsService = analyticsService;
        _this.stateService = stateService;
        _this.router = router;
        _this.rendition = ProductTypeRenditionEnum.default;
        return _this;
    }
    NetflixServicesDetailsComponent.prototype.ngOnInit = function () {
        this.navigationService.setCurrentPageComponent(PageNames.DETAIL_PAGE_INTRO);
        this.pack = this.stateService.selectSnapshot(function (state) { return state.basket.selectedTvShopEntertainmentPack; });
        this.setCorrectPackIdIfNecessary();
        this.setRendition();
        this.analyticsService.onDetailPage([this.pack.omapiId]);
    };
    NetflixServicesDetailsComponent.prototype.ngOnDestroy = function () {
        this.navigationService.clearNavigation();
    };
    NetflixServicesDetailsComponent.prototype.ngAfterViewInit = function () {
        this.navigationService.resetNavigation();
        this.changeDetector.detectChanges();
        this.navigationService.registerPageElement(this.productDetailContentElement);
    };
    NetflixServicesDetailsComponent.prototype.goToOptionsPage = function () {
        if (!this.pack.subscribed) {
            this.stateService.setIsStreamingBundleOrder(true);
            this.router.navigate(['/product-details', this.pack.omapiId, 'option'], { queryParamsHandling: 'merge' });
        }
    };
    NetflixServicesDetailsComponent.prototype.setRendition = function () {
        if (this.pack.isStreamingBundle) {
            this.rendition = ProductTypeRenditionEnum.streamingBundle;
        }
        else if (this.pack.isStreamingStandaloneProduct) {
            this.rendition = ProductTypeRenditionEnum.netflixStandalone;
        }
        else if (this.pack.isGroupPack && this.pack.omapiId === TvShopEntertainmentPackGroupIds.NETFLIX_STANDALONE) {
            this.rendition = ProductTypeRenditionEnum.netflixStandalone;
        }
    };
    NetflixServicesDetailsComponent.prototype.setCorrectPackIdIfNecessary = function () {
        var _this = this;
        if (OmapiIdsUtils.NETFLIX_STANDALONE_PRODUCTS.some(function (sp) { return sp === _this.pack.omapiId; })) {
            this.pack = StreamingServicesUtil.getNetflixStandaloneGroup(this.stateService.selectSnapshot(function (state) { return state.tvShopEntertainmentPackGroups; }));
        }
    };
    return NetflixServicesDetailsComponent;
}(NavigableComponent));
export { NetflixServicesDetailsComponent };
